
import React, { Component } from 'react';
import { Modal, FormGroup, Button, Input, Label } from 'reactstrap';
import Spinner from "react-spinners/ScaleLoader";
import { IoIosCloseCircleOutline } from "react-icons/io"
import ReactPinField from "react-pin-field"
import Switch from "react-switch";

const stringUtil = require('../../../../utils/string/stringUtil');
const validator = require('../../../../utils/validator/validator');
const stateManager = require('../../../../utils/state/stateManager');
const userApiProxy = require('../../../../utils/api/userApiProxy');
const viewUtil = require('../../../../utils/view/viewUtil');
const basketUtil = require('../../../../utils/basket/basketUtil');
const fatalErrorAction = require('../../../../utils/state/actions/error/fatalErrorAction');
const configurationManager = require('../../../../utils/config/configurationManager');
const storageUtil = require('../../../../utils/storage/storageUtil');

class User extends Component 
{
    constructor(props)
    {
        super(props);
        
        this.state = {};
        this.state.user = {
                            phoneNumber: "",
                            verificationCode: "",
                            
                            isUserVerified: false,
                            isUserRegistered: false,

                            remoteUser: null,
                           };

        this.state.waitMessage = "Please wait, while loading your details";
        this.state.stage = 0;
        this.loadUserFromCache()
    }

    render()
    {
        var childComponent = null;
       
        if (this.state.stage == 1)
            childComponent = this.renderUserDetails();
       
        if (this.state.stage == 2)
            childComponent = this.renderPhoneNumberDetails();
       
        if (this.state.stage == 3)
            childComponent = this.renderPinDetails();
       
        if(this.state.stage == 0)
        {
            return this.renderWaitMessage();
        }

        return <Modal isOpen={true} centered size="lg" style={{marginBottom:'30px', maxWidth: '600px'}}>
                    <div className='AppBar'>
                        <table style={{width:'100%'}}>
                            <tr>
                                <td style={{width:'99%'}}>
                                    <div style={{paddingLeft:'10px', paddingRight:'10px',paddingTop:'0px', marginTop:'5px'}}>
                                        Your Details
                                    </div>

                                </td>
                                <td style={{whiteSpace:'nowrap'}}>
                                    <div style={{marginTop:'5px', marginLeft:'10px', marginRight:'5px', fontSize:`var(--button-close-size)`, color:`var(--button-close-color)`}}
                                        onClick={()=>
                                                {
                                                    this.props.onDismiss();
                                                }}>
                                        <IoIosCloseCircleOutline/>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    
                    {childComponent}
                </Modal>
        
    }

    renderWaitMessage()
    {
        return (<Modal isOpen={true} centered>
                    <div style={{margin: '50px 10px'}}>
                        <div style={{textAlign:'center', whiteSpace:'nowrap', marginBottom: '10px'}}>
                            {this.state.waitMessage}
                        </div>
                        <div style={{textAlign:'center', whiteSpace:'nowrap'}}>
                            <Spinner color={`var(--spinner-color)`} size={40}/>
                        </div>
                    </div>
                </Modal>);
    }

    loadUserFromCache()
    {
        var appConfig = configurationManager.getAppConfig();
        storageUtil.readData(storageUtil.UserStoreName, appConfig.webOrderingExpiryForCachedUserPhoneNumber)
        .then(async (response)=>
                {
                    if (response == null)
                    {
                        
                        this.state.stage = 2;
                        this.setState({});
                        return;
                    }

                    this.state.user.remoteUser = await userApiProxy.loadUser(response.phoneNumber);
                    if (this.state.user.remoteUser == null)
                    {
                        this.state.stage = 2;
                        this.setState({});
                        return;
                    }

                    this.state.user.isUserVerified = false;
                    this.state.stage = 1;
                    this.setState({});
                    return;

                }, (error) =>
                {
                    stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
                });
    }

    renderUserDetails()
    {
        var user = this.state.user;

        return <div style={{margin: '10px 20px 30px 20px'}}>
                    <div style={{textAlign:'center', fontWeight:'bold', marginTop:'20px', marginBottom:'20px'}}>Please confirm your details</div>
                    
                    <FormGroup>
                        <Label>Your Phone Number</Label>
                        <Input
                            type="text" placeholder="Please enter your phone number" 
                            value={user.remoteUser.phoneNumber} readOnly={true} disabled={true}
                          />
                    </FormGroup>

                    <FormGroup>
                        <Label>Your Name</Label>
                        <Input
                            type="text" placeholder="Please enter your name" 
                            value={user.remoteUser.name}
                            disabled={!this.state.user.isUserVerified}
                            onChange={(event)=>
                                {
                                    user.remoteUser.name = event.target.value;
                                    this.setState({});
                                }}
                          />
                    </FormGroup>

                    {this.renderAddressDetails(user)}
                    
                    <FormGroup>
                        <Label>Your Email</Label>
                        <Input
                            type="text" placeholder="Please enter your email address" 
                            value={user.remoteUser.emailAddress}
                            disabled={!this.state.user.isUserVerified}
                            onChange={(event)=>
                                {
                                    user.remoteUser.emailAddress = event.target.value;
                                    this.setState({});
                                }}
                          />
                    </FormGroup>
                    <FormGroup>
                        <table style={{width:'100%'}}>
                            <tr>
                                <td style={{width:'99%'}}>
                                    You are ok if we contact you for our new offers
                                </td>
                                <td style={{whiteSpace:'nowrap', marginLeft: '10px'}}>
                                    <Switch className="react-switch" 
                                            checked={user.remoteUser.textNotificationEnabledForOffers} 
                                            disabled={!this.state.user.isUserVerified}
                                            onChange={(checked)=>
                                            {
                                                user.remoteUser.textNotificationEnabledForOffers = checked;
                                                this.setState({});
                                            }}/>
                                </td>
                            </tr>
                        </table>
                    </FormGroup>

                    <FormGroup>
                        <table style={{width:'100%'}}>
                            <tr>
                                <td style={{width:'99%'}}>
                                    You are ok if we contact you for any of your order updates
                                </td>
                                <td style={{whiteSpace:'nowrap'}}>
                                    <Switch className="react-switch"                                            
                                            checked={user.remoteUser.textNotificationEnabledForOrderUpdates} 
                                            disabled={!this.state.user.isUserVerified}
                                            onChange={(checked)=>
                                                {
                                                    user.remoteUser.textNotificationEnabledForOrderUpdates = checked;
                                                    this.setState({});
                                                }}/>
                                </td>
                            </tr>
                        </table>
                    </FormGroup>

                    <div style={{textAlign:'center'}}>

                    {
                        !this.state.user.isUserVerified ?
                                <Button disabled={!this.isRemoteUserDetailsValid()}
                                    style={{
                                                color:`var(--button-change-font-color)`, 
                                                background:`var(--button-change-background-color)`,
                                                borderColor:`var(--button-change-background-color)`,
                                                fontSize:`var(--button-change-font-size)`,
                                                paddingLeft:'20px',
                                                paddingRight:'20px',                                                
                                                paddingTop:'10px',
                                                paddingBottom:'10px',
                                                width:'80%',
                                                borderRadius:15,
                                                marginTop:'10px'
                                            }}
                                    onClick={()=>
                                            {
                                                this.state.stage = 2;
                                                this.setState({});
                                                return;
                                            }}>Change Details
                                </Button> :
                            null
                    }

                    

                    <Button disabled={!this.isRemoteUserDetailsValid()}
                        style={{
                                    color:`var(--button-continue-font-color)`, 
                                    background:`var(--button-continue-background-color)`,
                                    borderColor:`var(--button-continue-background-color)`,
                                    fontSize:`var(--button-continue-font-size)`,
                                    paddingLeft:'20px',
                                    paddingRight:'20px',                                                                        
                                    paddingTop:'10px',
                                    paddingBottom:'10px',
                                    width:'80%',
                                    borderRadius:15,
                                    marginTop:'10px'
                                }}
                        onClick={()=>
                                {
                                    this.updateUserDetails();
                                }}>Continue
                    </Button>
                    </div>
               </div>
    }

    renderAddressDetails(user)
    {
        if (!basketUtil.isAddressMandatoryForBasket())
            return null;
            
        return <FormGroup>
                    <Label>Your Address</Label>
                    <Input
                        type="text" placeholder="Please enter your address" 
                        value={user.remoteUser.address}
                        disabled={!this.state.user.isUserVerified}
                        onChange={(event)=>
                            {
                                user.remoteUser.address = event.target.value;
                                this.setState({});
                            }}
                    />
                </FormGroup>
    }

    renderPhoneNumberDetails()
    {
        var user = this.state.user;
        var width = Math.round(window.innerWidth * 0.28);
        return (<div style={{margin: '50px 10px 30px 10px', alignItems:'center', display:'flex', justifyContent:'center', flexDirection:'column'}}>
                    <div style={{textAlign:'center', whiteSpace:'nowrap'}}>Please enter your phone number</div>
                    <div style={{marginTop:'15px'}}>
                        <Input inputMode='numeric' style={{width:`${width}px`}} type="email" name="email" id="exampleEmail" placeholder="Phone Number" 
                                onChange={(event) =>
                                {
                                    user.phoneNumber = event.target.value;
                                    this.setState({});
                                }}/>
                    </div>
                    <Button disabled={!validator.isValidPhoneNumber(user.phoneNumber)}
                        style={{
                                    color:`var(--button-continue-font-color)`, 
                                    background:`var(--button-continue-background-color)`,
                                    borderColor:`var(--button-continue-background-color)`,
                                    fontSize:`var(--button-continue-font-size)`,
                                    marginTop:'40px',
                                    paddingLeft:'20px',
                                    paddingRight:'20px',                                    
                                    paddingTop:'10px',
                                    paddingBottom:'10px',
                                    width:'80%',
                                    borderRadius:15,                                    
                                }}
                        onClick={()=>
                                {
                                    this.onPhoneNumberEnter();
                                }}>Continue
                    </Button>
                    
                </div>);
    }

    onPhoneNumberEnter()
    {
        var user = this.state.user;
        this.state.stage = 0;
        this.state.waitMessage = "Please wait, while sending verification code";
        this.setState({});

        userApiProxy.getPinCode(user.phoneNumber)
        .then(response =>
            {
                this.state.stage = 3;
                this.state.waitMessage = "";
                user.verificationCode = response;
                this.setState({});
            }, error =>
            {
                stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
            });
    }

    renderPinDetails()
    {
        var user = this.state.user;
        return (<div style={{margin: '50px 10px 50px 10px', alignItems:'center', display:'flex', justifyContent:'center', flexDirection:'column'}}>
                    <div style={{marginBottom: '25px',textAlign:'center'}}>
                        We have sent you a verification code to {user.phoneNumber}.<br/> Please enter it below
                    </div>
                    <ReactPinField inputMode='numeric' class="pin-field" length={4}
                                    onComplete={(code)=>
                                    {
                                        document.activeElement.blur();
                                        if (!stringUtil.areStringSame(code, user.verificationCode))
                                        {
                                            viewUtil.showErrorAlert("Pin does not match");
                                            return;
                                        }

                                        this.loadUserDetailsFromPhoneNumber();
                                    }}/>
                </div>);
    }

    loadUserDetailsFromPhoneNumber()
    {
        var user = this.state.user;
        this.state.stage = 0;
        this.state.waitMessage = "Please wait, while loading details";
        this.setState({});

        userApiProxy.loadUser(user.phoneNumber)
        .then(response =>
            {
                user.remoteUser = response;
                user.isUserVerified = true;
                user.isUserRegistered = user.remoteUser != null;
                if (user.remoteUser == null)
                {
                    user.remoteUser = {};
                    user.remoteUser.phoneNumber = user.phoneNumber;
                    user.remoteUser.textNotificationEnabledForOffers = false;
                    user.remoteUser.textNotificationEnabledForOrderUpdates = false;
                }
                this.state.stage = 1;
                this.state.waitMessage = "";
                this.setState({});
            }, error =>
            {
                stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
            });
    }

    isRemoteUserDetailsValid()
    {
        var remoteUser = this.state.user.remoteUser;

        if (stringUtil.isStringNullOrEmpty(remoteUser.phoneNumber))
            return false;

        if (stringUtil.isStringNullOrEmpty(remoteUser.name))
            return false;

        if (!stringUtil.isStringNullOrEmpty(remoteUser.emailAddress) &&
            !validator.isValidEmailAddress(remoteUser.emailAddress))
            return false;

        if (basketUtil.isAddressMandatoryForBasket() &&
            stringUtil.isStringNullOrEmpty(remoteUser.address))
            return false;
        return true;
    }

    updateUserDetails()
    {
        this.state.stage = 0;
        this.state.waitMessage = "Please wait, while updating details";
        this.setState({});

        var store = stateManager.getStore();
        var state = store.getState();
        var basket = state.basket;

        userApiProxy.updateUser(this.state.user.remoteUser)
        .then(async response =>
            {
                state.user = response;
                var cachedUser = {};
                cachedUser.phoneNumber = response.phoneNumber;
                storageUtil.updateData(storageUtil.UserStoreName, cachedUser);

                basket.dispatchInfo.deliveryAddress= "";
                basket.dispatchInfo.distance= -1;
                basket.dispatchInfo.deliveryCharges= -1;
                basketUtil.markBasketForEnrichment();
                basket.order.customerId = state.user.id;

                if (stringUtil.areStringSame(basket.order.dispatchType, "Delivery"))
                {
                    basket.dispatchInfo.deliveryAddress = state.user.address;
                }

                this.props.onCompletion();

            }, error =>
            {
                store.dispatch(fatalErrorAction.createAction(error));
            });
    }
}

export default User;